import { Navigate, Route, Routes } from "react-router-dom";
import MainLayout from "../layouts/MainLayout";
import ErrorLayout from "../layouts/ErrorLayout";
import CustomersList from "modules/dashboards/home/CustomerList";
import CustomerChat from "pages/CustomerChat";
import CustomerFeedback from "pages/CustomerFeedback";
import IvrCall from "../pages/IvrCall";
import Engagement from "pages/Engagement";
import Login from "modules/user_login/Login";
import Home from "../pages/Home";
import RevenueReport from "modules/dashboards/revenue-report";
import NextCall from "modules/nextcall";
import EngagementSummary from "pages/EngagementSummary";
import Error404 from "modules/errors/Error404";
import Error500 from "modules/errors/Error500";
import Cookies from "js-cookie";
import ActionableList from "pages/ActionableList";
import Tickets from "pages/MyTickets";
import EngagementRep from "pages/EngagementRep";
import Dashboard from "modules/dashboards/Dashboard";
import LeadDetails from "modules/dashboards/actionables/LeadDetails";
import ManageWeekly from "pages/ManageWeekly";
import MyTeam from "pages/MyTeam";
import MedRepEngagement from "modules/medrep_engagement/MedRepEngagement";
import CallStats from "pages/CallStats";
import PrescribedPatients from "pages/PrescribedPatients";
import DoctorBooking from "pages/DoctorBooking";
import DoctorDashboard from "pages/AllopathyDoctorDashboard";
import { getCurrentUserRole, homeRoute } from "modules/utilities/utility";
import DoctorsTab from "pages/DoctorsDashboard";
import ResetPassword from "modules/user_login/ResetPassword";
import OrderMovement from "modules/order_management/OrderMovement";
import SupportFeedback from "pages/SupportFeedback";
import SlotBookingLoggers from "pages/SlotBookingLoggers";
import Community from "pages/Community";
import CommunityPage from "modules/community/CommunityPage";
import TodayEngagement from "modules/medrep_engagement/TodayEngagement";
import Feedback from "modules/support_feedback/Feedback";
import AllOrdersManagement from "modules/order_management/AllOrdersManagement";
import UpdateOrders from "pages/UpdateOrders";
import Invoice from "pages/InvoiceGenerate";
import SalesManagement from "modules/case_management/SalesManagement";
import AllLeads from "modules/case_management/AllLeads";
import CaseSlotBooking from "modules/case_management/CaseSlotBooking";
import Reports from "pages/Reports";
import Zoho from "modules/zoho/Zoho";
import Warehouse from "pages/Warehouse";
import OpenOrders from "pages/OpenOrders";
import RecentOrders from "pages/RecentOrders";
import AssignedDoctors from "pages/AssignedDoctors";
import TicketingSettings from "pages/TicketingSettings";
import UserManagement from "modules/user_management/UserManagement";
import RevenueTracker from "pages/RevenueTracker";
import ODAList from "../pages/oda/components/ODA";
import MedRepEngagements from "modules/manage_weekly-schedule/MedRepEngagements";
import GroupManagement from "pages/GroupManagement";
import DiscountCodes from "pages/DiscountCodes";
import MyAppointment from "pages/MyAppointment";
import ManageSegment from "pages/ManageSegment";
import ManageContents from "pages/ManageContents";
import ManageTag from "pages/ManageTag";
import ManageComponents from "pages/ManageComponents";
import EditUsers from "modules/user_management/EditUsers";
import SegmentDetail from "modules/manage_segment/SegmentDetail";
import TagDetail from "modules/manage_tags/TagDetail";
import AdminCaseManagement from "pages/AdminCaseManagement";
import Search from "pages/dispatchSearch/Search";
import DashboardDispatch from "pages/dispatchDashboard/DashboardDispatch";
import AdminDashboard from "pages/AdminDashboard";
import Medicines from "pages/Medicines";
import Tags from "pages/Tags";
import ProductMapping from "pages/ProductMapping";
import Settings from "pages/Settings";
import GhostOrders from "pages/GhostOrders";
import FinanceDashboard from "pages/FinanceDashboard";
import MasterTable from "modules/master_table/MasterTable";
import PayementGateway from "modules/payment_gateway/PayementGateway";
import UtmCampaign from "pages/UtmCampaign";
import PerformanceDashboard from "pages/PerformanceDashboard";
import DefaultDashboard from "modules/falcon_dashboard/DefaultDashboard";
import EcommerceDashboard from "modules/falcon_dashboard/EcommerceDashboard";
import LmsDashboard from "modules/falcon_dashboard/LmsDashboard";
import ManagementDashboard from "modules/falcon_dashboard/ManagementDashboard";
import SaasDashboard from "modules/falcon_dashboard/SaasDashboard";
import SupportDeskDashboard from "modules/falcon_dashboard/SupportDeskDashboard";
import RewardPoints from "pages/RewardPoints";
import FailedUniOrdersTable from "modules/unicommerce/FailedUniOrdersTable";
import WarehousePincodeMapping from "pages/WarehousePincodeMapping";
import MedicalEscalationTickets from "modules/my_tickets/MedicalEscalationTickets";
import TicketGroups from "pages/TicketGroups";
import PincodeManagement from "modules/pincode_management/PincodeManagement";
import VayuLead from "modules/vayu_lead/VayuLead";
import InputOTPPage from "modules/user_login/LoginWithZoho";
import Clinics from "modules/clinic-management/Clinics";
import ClinicsDashBoard from "modules/clinic-management/ClinicsDashBoard";
import AllLeadsTag from "modules/case_management/AllLeadsTag";
import ProductivityDashboard from 'modules/productivity_dashboard/ProductivityDashboard';
import FeedbackTab from 'modules/support_feedback/FeedbackTab';
import TicketConfigure from 'pages/TicketConfigure';
import SSOT from "modules/user_management/SSOT";
import secureLocalStorage from 'react-secure-storage';
import CovinDashboard from 'modules/covin_dashboard/CovinDashboard';
import NotificationConfigure from 'pages/waba_configure/NotificationConfigure';


// Importing Attendance and Leave tracker
import AttendanceTracker from 'modules/attendence_leave_tracker/AttendanceTracker';
import LeaveTracker from 'modules/attendence_leave_tracker/LeaveTracker';
import ApprovalsTracker from 'modules/attendence_leave_tracker/ApprovalsTracker';
import MyWork from 'modules/qa_integration/MyWork';
import MainContent from 'modules/qa_integration/MainContent';
import QaRecordingFeedback from 'modules/qa_integration/QaRecordingFeedback';
import CallingKpi from 'modules/kpi_dashboard/CallingKpi';
import MedicalIncentives from 'modules/medical_incentives/MedicalIncentives';
import ComplaintIncentives from 'modules/complaints_incentives/ComplaintIncentives';
import CallingIncentives from 'modules/allIncentiveDashboard/callingIncentiveDashboard/CallingIncentives';
import IncentiveSlab from 'modules/allIncentiveDashboard/incentiveSlabDashboard/IncentiveSlab';
import WeightageAndTarget from 'modules/allIncentiveDashboard/weightageAndTargetDashboard/WeightageAndTarget';
import AchievedScore from 'modules/allIncentiveDashboard/incentiveAcheivedScoreDashboard/AchievedScore';
import IdeaDashboard from 'modules/ideal_time_calculator/IdeaDashboard';
import ComplaintKpi from 'modules/complaints_kpi_dashboard/ComplaintKpi';
import MedicalKpi from 'modules/medical_kpi_dashboard/MedicalKpi';
import SlotBookingEngagement from 'modules/emgagement_report/SlotBookingEngagement';
import KpiDashboardHistory from "modules/kpi_dashboard/KpiDashboardHistory";
import QA_questions from "modules/qa_questions/QA_questions";
import LocationView from 'modules/qa_integration/LocationView';
import CoachView from 'modules/qa_integration/CoachView';
import QAView from 'modules/qa_integration/QAView';
import ReportDashboard from 'modules/Shopify_dashboard/ReportDashboard';
import ReturnOrders from 'modules/order_management/ReturnOrders';
import OTSManagment from 'modules/Ots_mangment/OTSManagment';
import MonthReport from 'modules/mtd_report/MonthReport';
import ReceptionistTodayEngagement from "../modules/medrep_engagement/ReceptionistTodayEngagement";

const CRMRoutes = () => {
  const token = Cookies.get('token');
  const userRole = getCurrentUserRole();
  const currentUserLevel = secureLocalStorage.getItem('level');

  const userSpecificRoutes = () => {
    switch (userRole) {
      case "medical_rep":
        return (
          <>
            <Route path="dashboard" element={<Dashboard />} />
            <Route
              path="/"
              element={<Navigate to={"/dashboard?tab=home"} replace />}
            />
            <Route
              path="/medical-esaclation-tickets"
              element={<MedicalEscalationTickets />}
            />
            <Route path="/main-content" element={<MainContent />} />
            <Route path="/recording-feedback/:engagementTrackingId/:engagementCoachUserId" element={<QaRecordingFeedback />} />
            {currentUserLevel == '3' ? (
              <>
                <Route
                  path="/dashboard/home/assigned-orders"
                  element={<CustomersList assignedOrder={true} />}
                />
                <Route path="/next-call" element={<NextCall />} />
                <Route
                  path="/next-call/:id"
                  element={<LeadDetails nextCall={true} />}
                />
                <Route
                  path="dashboard/revenue-report"
                  element={<RevenueReport />}
                />
                <Route
                  path="dashboard/actionables"
                  element={<ActionableList />}
                />
                <Route path="ivrCall" element={<IvrCall />} />
                <Route path="dashboard/engagement" element={<Engagement />} />
                <Route path="customerFeedback" element={<CustomerFeedback />} />
                <Route path="customerChats" element={<CustomerChat />} />
                <Route
                  path="/manage-weekly-schedules"
                  element={<ManageWeekly />}
                />
                <Route
                  path="dashboard/revenue-report"
                  element={<RevenueReport />}
                />
                <Route path="engagementReport" element={<EngagementRep />} />
                <Route path="/call-stats" element={<CallStats />} />
                <Route path="myteam" element={<MyTeam />} />
                <Route
                  path="today-engagement/:id"
                  element={<MedRepEngagement />}
                />
                <Route
                  path="/medRep-engagement"
                  element={<MedRepEngagements />}
                />
              </>
            ) : (
              <>
                <Route
                  path="/dashboard/home/assigned-orders"
                  element={<CustomersList assignedOrder={true} />}
                />
                <Route path="/next-call" element={<NextCall />} />
                <Route
                  path="/next-call/:id"
                  element={<LeadDetails nextCall={true} />}
                />
                <Route
                  path="dashboard/revenue-report"
                  element={<RevenueReport />}
                />
                <Route
                  path="dashboard/actionables"
                  element={<ActionableList />}
                />
                <Route path="ivrCall" element={<IvrCall />} />
                <Route path="dashboard/engagement" element={<Engagement />} />
                <Route path="customerFeedback" element={<CustomerFeedback />} />
                <Route path="customerChats" element={<CustomerChat />} />
                <Route
                  path="dashboard/revenue-report"
                  element={<RevenueReport />}
                />
                <Route path="engagementReport" element={<EngagementRep />} />
                <Route path="/call-stats" element={<CallStats />} />
              </>
            )}
            {/* Added Attendance & Leave Tracker */}
            <Route path='/attendance-tracker' element={<AttendanceTracker />} />
            <Route path='/leave-tracker' element={<LeaveTracker />} />
          </>
        );
      case "medrep_ext":
        return (
          <>
            <Route path="dashboard" element={<Dashboard />} />
            <Route
              path="/"
              element={<Navigate to={"/dashboard?tab=home"} replace />}
            />
            <>
              <Route
                path="/dashboard/home/assigned-orders"
                element={<CustomersList assignedOrder={true} />}
              />
              <Route path="/next-call" element={<NextCall />} />
              <Route
                path="/next-call/:id"
                element={<LeadDetails nextCall={true} />}
              />
              <Route
                path="dashboard/revenue-report"
                element={<RevenueReport />}
              />
              <Route path='engagementReport' element={<EngagementRep />} />
              <Route path='/call-stats' element={<CallStats />} />

              {/* Added Attendance & Leave Tracker */}
              <Route path='/attendance-tracker' element={<AttendanceTracker />} />
              <Route path='/leave-tracker' element={<LeaveTracker />} />
            </>
          </>
        );
      case "consult_doctor":
        return (
          <>
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="doctor-booking" element={<DoctorBooking />} />
            <Route path="/" element={<Navigate to={"/dashboard"} replace />} />
          </>
        );
      case "doctor":
        return (
          <>
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="doctor-booking" element={<DoctorBooking />} />
            <Route path="/my-appointments" element={<MyAppointment />} />
            <Route
              path="/prescribed-patients"
              element={<PrescribedPatients />}
            />
          </>
        );
      case "read_only":
        return (
          <>
            <Route path="/dashboard" element={<Dashboard />} />
          </>
        );
      case 'lead_agent':
      case 'chat_call_agent':
        return (
          <>
            <Route path='lead-dashboard' element={<TodayEngagement />} />
            <Route path='/invoice' element={<Invoice />} />
            <Route path='/order-management' element={<OrderMovement />} />
            <Route path='customerFeedback' element={<CustomerFeedback />} />
            <Route
              path="case-management/sales-management"
              element={<SalesManagement />}
            />
            <Route path="/case-management/all-leads" element={<AllLeads />} />
            <Route path="/case-management/new-leads" element={<AllLeads />} />
            <Route path="/case-management/all-cases" element={<AllLeads />} />
            <Route path="doctor-booking" element={<DoctorBooking />} />
            <Route path="/feedback" element={<SupportFeedback />} />
            <Route path="/customer-feedback" element={<Feedback />} />
            <Route
              path="/order-management/allOrder"
              element={<AllOrdersManagement />}
            />
            <Route
              path="/case-management/slotBooking"
              element={<CaseSlotBooking />}
            />
            <Route
              path="/order-management/update_order"
              element={<UpdateOrders />}
            />
            <Route path='/next-call' element={<NextCall />} />
            <Route
             path='/next-call/:id' element={<LeadDetails nextCall={true} />}
            />

            {/* Added Attendance & Leave Tracker */}
            <Route path='/attendance-tracker' element={<AttendanceTracker />} />
            <Route path='/leave-tracker' element={<LeaveTracker />} />
            <Route path='/utm_campaign' element={<UtmCampaign />} />
          </>
        );
      case "support":
        return (
          <>
            <Route path="/invoice" element={<Invoice />} />
            <Route path="/order-management" element={<OrderMovement />} />
            <Route path="customerFeedback" element={<CustomerFeedback />} />
            <Route
              path="case-management/sales-management"
              element={<SalesManagement />}
            />
            <Route path="/case-management/all-leads" element={<AllLeads />} />
            <Route path="/case-management/new-leads" element={<AllLeads />} />
            <Route path="/case-management/all-cases" element={<AllLeads />} />
            <Route path="doctor-booking" element={<DoctorBooking />} />
            <Route path="/feedback" element={<SupportFeedback />} />
            <Route path="/customer-feedback" element={<Feedback />} />
            <Route
              path="/order-management/allOrder"
              element={<AllOrdersManagement />}
            />
            <Route
              path="/case-management/slotBooking"
              element={<CaseSlotBooking />}
            />
            <Route
              path="/order-management/update_order"
              element={<UpdateOrders />}
            />

            {/* Added Attendance & Leave Tracker */}
            <Route path='/attendance-tracker' element={<AttendanceTracker />} />
            <Route path='/leave-tracker' element={<LeaveTracker />} />

            {/* Added Quality Analysis */}
            <Route path="/main-content" element={<MainContent />} />
            <Route path="/my-work" element={<MyWork />} />
            <Route path="/recording-feedback/:engagementTrackingId/:engagementCoachUserId" element={<QaRecordingFeedback />} />
            <Route path="/slot-booking-total" element={<SlotBookingEngagement/>} />
          </>
        );
      case "operations":
        return (
          <>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route
              path="/dashboard/home/assigned-orders"
              element={<CustomersList assignedOrder={true} />}
            />
            <Route path="/next-call" element={<NextCall />} />
            <Route
              path="/next-call/:id"
              element={<LeadDetails nextCall={true} />}
            />
            <Route
              path="dashboard/revenue-report"
              element={<RevenueReport />}
            />
            <Route path="dashboard/actionables" element={<ActionableList />} />
            <Route path="ivrCall" element={<IvrCall />} />
            <Route path="dashboard/engagement" element={<Engagement />} />
            <Route path="customerFeedback" element={<CustomerFeedback />} />
            <Route path="customerChats" element={<CustomerChat />} />
            <Route
              path="dashboard/revenue-report"
              element={<RevenueReport />}
            />
            <Route path='engagementReport' element={<EngagementRep />} />

            {/* Added Attendance & Leave Tracker */}
            <Route path='/attendance-tracker' element={<AttendanceTracker />} />
            <Route path='/leave-tracker' element={<LeaveTracker />} />
          </>
        );
      case "community":
        return (
          <>
            {currentUserLevel == '2' ? (
              <>
                <Route path="/invoice" element={<Invoice />} />
                <Route path="/order-management" element={<OrderMovement />} />
                <Route path="customerFeedback" element={<CustomerFeedback />} />
                <Route
                  path="case-management/sales-management"
                  element={<SalesManagement />}
                />
                <Route
                  path="/case-management/all-leads"
                  element={<AllLeads />}
                />
                <Route
                  path="/case-management/new-leads"
                  element={<AllLeads />}
                />
                <Route
                  path="/case-management/all-cases"
                  element={<AllLeads />}
                />
                <Route path="doctor-booking" element={<DoctorBooking />} />
                <Route path="/feedback" element={<SupportFeedback />} />
                <Route path="/customer-feedback" element={<Feedback />} />
                <Route
                  path="/order-management/allOrder"
                  element={<AllOrdersManagement />}
                />
                <Route
                  path="/case-management/slotBooking"
                  element={<CaseSlotBooking />}
                />
                <Route
                  path="/order-management/update_order"
                  element={<UpdateOrders />}
                />
                <Route path="community" element={<Community />} />
                <Route path="/community-details" element={<CommunityPage />} />

                {/* Added Attendance & Leave Tracker */}
                <Route path='/attendance-tracker' element={<AttendanceTracker />} />
                <Route path='/leave-tracker' element={<LeaveTracker />} />
              </>
            ) : (
              <>
                <Route path="/myTickets" element={<Tickets />} />
                <Route path="community" element={<Community />} />
                <Route path="/community-details" element={<CommunityPage />} />
              </>
            )}

            {/* Added Attendance & Leave Tracker */}
            <Route path='/attendance-tracker' element={<AttendanceTracker />} />
            <Route path='/leave-tracker' element={<LeaveTracker />} />
          </>
        );
      case "quality":
        return (
          <>
            <Route path="/case-management/all-cases" element={<AllLeads />} />
            <Route path="/case-management/new-leads" element={<AllLeads />} />
            <Route path="/case-management/all-leads/" element={<AllLeads />} />
            <Route path="/customer-feedback" element={<Feedback />}></Route>
            <Route path="/customerFeedback" element={<CustomerFeedback />} />
            <Route path="/myTickets" element={<Tickets />} />
            <Route path="doctor-booking" element={<DoctorBooking />} />
            <Route path="engagementReport" element={<EngagementRep />} />
            <Route path='/feedback' element={<FeedbackTab />} />
            <Route
              path="/case-management/slotBooking"
              element={<CaseSlotBooking />}
            />
            <Route
              path="case-management/sales-management"
              element={<SalesManagement />}
            />

            {/* Added Attendance & Leave Tracker */}
            <Route path='/attendance-tracker' element={<AttendanceTracker />} />
            <Route path='/leave-tracker' element={<LeaveTracker />} />

          </>
        );
      case "chat":
        return (
          <>
            <Route path='/customerFeedback' element={<CustomerFeedback />} />
            <Route path='/order-management' element={<OrderMovement />} />
            <Route path='/invoice' element={<Invoice />} />

            {/* Added Attendance & Leave Tracker */}
            <Route path='/attendance-tracker' element={<AttendanceTracker />} />
            <Route path='/leave-tracker' element={<LeaveTracker />} />
          </>
        );
      case "orm":
        return (
          <>
            <Route path="/order-management" element={<OrderMovement />} />
            <Route path="/invoice" element={<Invoice />} />

            {/* Added Attendance & Leave Tracker */}
            <Route path='/attendance-tracker' element={<AttendanceTracker />} />
            <Route path='/leave-tracker' element={<LeaveTracker />} />
          </>
        );
      case "medical":
        return (
          <>
            <Route
              path="/order-management/allOrder"
              element={<AllOrdersManagement />}
            />
            <Route path="doctor-booking" element={<DoctorBooking />} />
            <Route
              path="/medical-esaclation-tickets"
              element={<MedicalEscalationTickets />}
            />
            {/* Added Quality Analysis */}
            <Route path="/main-content" element={<MainContent />} />
            <Route path="/recording-feedback/:engagementTrackingId/:engagementCoachUserId" element={<QaRecordingFeedback />} />

            {/* Added Attendance & Leave Tracker */}
            <Route path='/attendance-tracker' element={<AttendanceTracker />} />
            <Route path='/leave-tracker' element={<LeaveTracker />} />
            <Route path="/main-content" element={<MainContent />} />
          </>
        );
      case "operations_admin":
        return (
          <>
            <Route path="zoho" element={<Zoho />} />
            <Route path="warehouse" element={<Warehouse />} />
            <Route path="revenue-tracking" element={<RevenueTracker />} />
            <Route path="/misc-orders" element={<ODAList />} />
            <Route path="/invoice" element={<Invoice />} />
            <Route
              path="/order-management/update_order"
              element={<UpdateOrders />}
            />
            <Route
              path="/order-management/open_orders"
              element={<OpenOrders />}
            />
            <Route
              path="/order-management/recent_orders"
              element={<RecentOrders />}
            />
            <Route
              path="/order-management/assigned-doctors"
              element={<AssignedDoctors />}
            />
            <Route path="/order-management" element={<OrderMovement />} />
            <Route
              path="/order-management/allOrder"
              element={<AllOrdersManagement />}
            />

            {/* Added Attendance & Leave Tracker */}
            <Route path='/attendance-tracker' element={<AttendanceTracker />} />
            <Route path='/leave-tracker' element={<LeaveTracker />} />
          </>
        );
      case "super_admin":
        return (
          <>
          <Route path='/order-management/return-orders' element={<ReturnOrders />} />
          <Route path='/order-tracking-service' element={<OTSManagment/>} />
          <Route path='/idealtimecalculator' element={<IdeaDashboard />} />
            <Route path='dashboard' element={<Dashboard />} />
            <Route
              path="/engagementReport/summary"
              element={<EngagementSummary />}
            />
            <Route path='customerFeedback' element={<CustomerFeedback />} />
            <Route path='customerChats' element={<CustomerChat />} />
            <Route path='/feedback' element={<FeedbackTab />} />
            <Route path='community' element={<Community />} />
            <Route path='/community-details' element={<CommunityPage />} />
            <Route
              path="slot-booking-loggers"
              element={<SlotBookingLoggers />}
            />
            <Route path="/customer-feedback" element={<Feedback />}></Route>
            <Route path="/case-management/all-leads" element={<AllLeads />} />
            <Route path="/case-management/new-leads" element={<AllLeads />} />
            <Route path="/case-management/all-cases" element={<AllLeads />} />
            <Route
              path="case-management/sales-management"
              element={<SalesManagement />}
            />
            <Route path="/order-management" element={<OrderMovement />} />
            <Route
              path="/order-management/allOrder"
              element={<AllOrdersManagement />}
            />
            <Route path="doctor-booking" element={<DoctorBooking />} />
            <Route path="engagementReport" element={<EngagementRep />} />
            <Route path="/call-stats" element={<CallStats />} />
            <Route path="/user-management" element={<UserManagement />} />
            <Route path="/invoice" element={<Invoice />} />
            <Route
              path="/transactions-dashboard"
              element={<PayementGateway />}
            />
            <Route
              path="/case-management/slotBooking"
              element={<CaseSlotBooking />}
            />
            <Route path="/reports" element={<Reports />} />
            <Route
              path="/order-management/update_order"
              element={<UpdateOrders />}
            />
            <Route
              path="/order-management/open_orders"
              element={<OpenOrders />}
            />
            <Route
              path="/order-management/recent_orders"
              element={<RecentOrders />}
            />
            <Route
              path="/order-management/ghost-orders"
              element={<GhostOrders />}
            />
            <Route path="/manage-weekly-schedules" element={<ManageWeekly />} />
            <Route
              path="/order-management/assigned-doctors"
              element={<AssignedDoctors />}
            />
            <Route path='zoho' element={<Zoho />} />
            <Route path='warehouse' element={<Warehouse />} />
            <Route path='/configure-ticket' element={<TicketConfigure />} />
            <Route path='/notification-configure' element={<NotificationConfigure />} />
            <Route path='/ticket-group-management' element={<TicketGroups />} />
            <Route path='user-management' element={<UserManagement />} />
            <Route path='/revenue-tracking' element={<RevenueTracker />} />
            <Route path='/misc-orders' element={<ODAList />} />
            <Route path='/medRep-engagement' element={<MedRepEngagements />} />
            <Route path='/configure/medicines' element={<Medicines />} />
            <Route path='/configure/tags' element={<Tags />} />
            <Route
              path="/configure/product-mapping"
              element={<ProductMapping />}
            />
            <Route path="/configure/settings" element={<Settings />} />
            <Route path="/group-management" element={<GroupManagement />} />
            <Route path="/discount-codes" element={<DiscountCodes />} />
            <Route path="/admin-dashboard" element={<AdminDashboard />} />
            <Route
              path="/order-management/ghost-orders"
              element={<GhostOrders />}
            />
            <Route
              path="/admin-case-management"
              element={<AdminCaseManagement />}
            />
            <Route path="/financial-dashboard" element={<FinanceDashboard />} />
            <Route path='/report-dashboard' element={<ReportDashboard />} />
            <Route path='/mtd-report' element={<MonthReport /> } /> 
            <Route path="/manage-segments" element={<ManageSegment />} />
            <Route path="/manage-contents" element={<ManageContents />} />
            <Route path="/manage-tags" element={<ManageTag />} />
            <Route path="/manage-components" element={<ManageComponents />} />
            <Route
              path="/manage-segment/segmentDetail/:segmentId/:segmentName"
              element={<SegmentDetail />}
            />
            <Route
              path="/manage-tags/tagDetail/:tagId/:tagMasterName"
              element={<TagDetail />}
            />
            <Route path="/manage-master-table" element={<MasterTable />} />
            <Route path="/utm_campaign" element={<UtmCampaign />} />
            <Route
              path="/performance_dashboard"
              element={<PerformanceDashboard />}
            />
            <Route
              path="/falconDashboardDefault"
              element={<DefaultDashboard />}
            />
            <Route
              path="/eCommerceDashboard"
              element={<EcommerceDashboard />}
            />
            <Route path="/lmsDashboard" element={<LmsDashboard />} />
            <Route
              path="/managementDashboard"
              element={<ManagementDashboard />}
            />
            <Route path="/saasDashboard" element={<SaasDashboard />} />
            <Route path="/supportDesk" element={<SupportDeskDashboard />} />
            <Route path="reward-points" element={<RewardPoints />} />
            <Route
              path="/uni_commerce_dashboard"
              element={<FailedUniOrdersTable />}
            />
            <Route
              path="/warehouse-pincode-mapping"
              element={<WarehousePincodeMapping />}
            />
            <Route
              path="/medical-esaclation-tickets"
              element={<MedicalEscalationTickets />}
            />


            {/* Added Attendance & Leave Tracker */}
            <Route path='/attendance-tracker' element={<AttendanceTracker />} />
            <Route path='/leave-tracker' element={<LeaveTracker />} />
            <Route path='/approvals-tracker' element={<ApprovalsTracker />} />

            {/* Added Quality Analysis */}
            <Route path="/main-content" element={<MainContent />} />
            <Route path="/my-work" element={<MyWork />} />
            <Route path='/qa-questions' element={<QA_questions/>} />
            <Route path="/recording-feedback/:engagementTrackingId/:engagementCoachUserId" element={<QaRecordingFeedback />} />
            <Route path="/location-view" element={<LocationView/>} />
            <Route path="/coach-view" element={<CoachView/>} />
            <Route path="/qa-view" element={<QAView/>} />

            <Route path="/pincode-management" element={<PincodeManagement />} />
            <Route path="/case-management/vayu-lead" element={<VayuLead />} />
            <Route path="/ssot" element={<SSOT />} />
            <Route path='/Clinic-management' element={<Clinics />} />

            <Route path='/covin-dashboard' element={<CovinDashboard />} />

            {/* KPI Dashboard */}
            <Route path="/kpi-calling" element={<CallingKpi />} />
            <Route path="/kpi-historical-dashboard" element={<KpiDashboardHistory/>} />
            

            {/* Added Incentives Calculator */}
            <Route path="/incentives-slab" element={<IncentiveSlab/>} />
            <Route path="/incentives-achievedScore" element={<AchievedScore/>} />
            <Route path="/weightage-target" element={<WeightageAndTarget/>} />
            <Route path="/incentives-calculator" element={<CallingIncentives/>} />
            <Route path="/slot-booking-total" element={<SlotBookingEngagement/>} /> 
          </>
        );
      case "doctor_admin":
      case "admin":
        return (
          <>
          <Route path='/order-management/return-orders' element={<ReturnOrders />} />
          <Route path='/idealtimecalculator' element={<IdeaDashboard />} />
            <Route path='dashboard' element={<Dashboard />} />
            <Route
              path="/engagementReport/summary"
              element={<EngagementSummary />}
            />
            <Route path="customerFeedback" element={<CustomerFeedback />} />
            <Route path="customerChats" element={<CustomerChat />} />
            <Route path="/feedback" element={<SupportFeedback />}></Route>
            <Route path="community" element={<Community />} />
            <Route path="/community-details" element={<CommunityPage />} />
            <Route
              path="slot-booking-loggers"
              element={<SlotBookingLoggers />}
            />
            <Route path="/customer-feedback" element={<Feedback />}></Route>
            <Route path="/case-management/all-leads" element={<AllLeads />} />
            <Route path="/case-management/new-leads" element={<AllLeads />} />
            <Route path="/case-management/all-cases" element={<AllLeads />} />
            <Route
              path="case-management/sales-management"
              element={<SalesManagement />}
            />
            <Route path="/order-management" element={<OrderMovement />} />
            <Route
              path="/order-management/allOrder"
              element={<AllOrdersManagement />}
            />
            <Route path="doctor-booking" element={<DoctorBooking />} />
            <Route path="engagementReport" element={<EngagementRep />} />
            <Route path="/call-stats" element={<CallStats />} />
            <Route path="/user-management" element={<UserManagement />} />
            <Route path="/invoice" element={<Invoice />} />
            <Route
              path="/case-management/slotBooking"
              element={<CaseSlotBooking />}
            />
            <Route path="/reports" element={<Reports />} />
            <Route
              path="/order-management/update_order"
              element={<UpdateOrders />}
            />
            <Route
              path="/order-management/open_orders"
              element={<OpenOrders />}
            />
            <Route
              path="/order-management/recent_orders"
              element={<RecentOrders />}
            />
            <Route path="/manage-weekly-schedules" element={<ManageWeekly />} />
            <Route
              path="/order-management/assigned-doctors"
              element={<AssignedDoctors />}
            />
            <Route path="zoho" element={<Zoho />} />
            <Route path="warehouse" element={<Warehouse />} />
            <Route path="user-management" element={<UserManagement />} />
            <Route path="/revenue-tracking" element={<RevenueTracker />} />
            <Route path="/misc-orders" element={<ODAList />} />
            <Route path="/medRep-engagement" element={<MedRepEngagements />} />
            <Route
              path="/admin-case-management"
              element={<AdminCaseManagement />}
            />
            <Route path="/group-management" element={<GroupManagement />} />
            <Route path="/admin-dashboard" element={<AdminDashboard />} />
            <Route
              path="/order-management/ghost-orders"
              element={<GhostOrders />}
            />
            <Route
              path="/performance_dashboard"
              element={<PerformanceDashboard />}
            />
            <Route path="reward-points" element={<RewardPoints />} />
            <Route
              path="/falconDashboardDefault"
              element={<DefaultDashboard />}
            />
            <Route
              path="/eCommerceDashboard"
              element={<EcommerceDashboard />}
            />
            <Route path="/lmsDashboard" element={<LmsDashboard />} />
            <Route
              path="/managementDashboard"
              element={<ManagementDashboard />}
            />
            <Route path="/saasDashboard" element={<SaasDashboard />} />
            <Route path="/supportDesk" element={<SupportDeskDashboard />} />
            <Route
              path="/uni_commerce_dashboard"
              element={<FailedUniOrdersTable />}
            />
            <Route
              path="/warehouse-pincode-mapping"
              element={<WarehousePincodeMapping />}
            />
            <Route
              path="/medical-esaclation-tickets"
              element={<MedicalEscalationTickets />}
            />

            {/* Added Attendance & Leave Tracker */}
            <Route path='/attendance-tracker' element={<AttendanceTracker />} />
            <Route path='/leave-tracker' element={<LeaveTracker />} />
            <Route path='/approvals-tracker' element={<ApprovalsTracker />} />

            {/* Added Quality Analysis */}
            <Route path="/main-content" element={<MainContent />} />
            <Route path="/my-work" element={<MyWork />} />
            <Route path='/qa-questions' element={<QA_questions/>} />
            <Route path="/recording-feedback/:engagementTrackingId/:engagementCoachUserId" element={<QaRecordingFeedback />} />
            <Route path="/location-view" element={<LocationView/>} />
            <Route path="/coach-view" element={<CoachView/>} />
            <Route path="/qa-view" element={<QAView/>} />

            <Route path="/ticket-group-management" element={<TicketGroups />} />
            <Route path="/pincode-management" element={<PincodeManagement />} />
            <Route path="/case-management/vayu-lead" element={<VayuLead />} />
            <Route path="/ssot" element={<SSOT />} />

            {/* Added Incentives Calculator */}
            <Route path="/incentives-slab" element={<IncentiveSlab/>} />
            <Route path="/incentives-achievedScore" element={<AchievedScore/>} />
            <Route path="/weightage-target" element={<WeightageAndTarget/>} />
            <Route path="/incentives-calculator" element={<CallingIncentives/>} />

            {/* Added Quality Analysis */}
            <Route path="/main-content" element={<MainContent />} />
            <Route path="/my-work" element={<MyWork />} />
            <Route path="/recording-feedback/:engagementTrackingId/:engagementCoachUserId" element={<QaRecordingFeedback />} />

            {/* KPI Dashboard */}
            <Route path="/kpi-calling" element={<CallingKpi />} />
            <Route path="/kpi-historical-dashboard" element={<KpiDashboardHistory/>} />

            <Route path="/ticket-group-management" element={<TicketGroups />} />
            <Route path="/pincode-management" element={<PincodeManagement />} />
            <Route path="/case-management/vayu-lead" element={<VayuLead />} />
            <Route path="/ssot" element={<SSOT />} />

            {/* Added Incentives Calculator */}
            <Route path="/incentives-slab" element={<IncentiveSlab/>} />
            <Route path="/incentives-achievedScore" element={<AchievedScore/>} />
            <Route path="/weightage-target" element={<WeightageAndTarget/>} />
            <Route path="/incentives-calculator" element={<CallingIncentives/>} />
            <Route path="/slot-booking-total" element={<SlotBookingEngagement/>} />

          </>
        );
      case "team_lead":
        return (
          <>
          <Route path='/idealtimecalculator' element={<IdeaDashboard />} />
           {/* <Route path='/invoice' element={<Invoice />} /> */}
            <Route path='/order-management' element={<OrderMovement />} />
            {/* <Route path='customerFeedback' element={<CustomerFeedback />} /> */}
            {/* <Route
              path='case-management/sales-management'
              element={<SalesManagement />}
            /> */}
            {/* <Route path='/case-management/all-leads' element={<AllLeads />} />
            <Route path='/case-management/new-leads' element={<AllLeads />} />
            <Route path='/case-management/all-cases' element={<AllLeads />} /> */}
            {/* <Route path='doctor-booking' element={<DoctorBooking />} /> */}
            {/* <Route path='/feedback' element={<FeedbackTab />} /> */}
            {/* <Route path='/customer-feedback' element={<Feedback />} /> */}
            {/* <Route
              path='/order-management/allOrder'
              element={<AllOrdersManagement />}
            /> */}
            {/* <Route
              path='/case-management/slotBooking'
              element={<CaseSlotBooking />}
            /> */}
            {/* <Route
              path='/order-management/update_order'
              element={<UpdateOrders />}
            /> */}
            <Route
              path="/manage-weekly-schedules"
              element={<ManageWeekly />}
            />
            <Route
              path="/medRep-engagement"
              element={<MedRepEngagements />}
            />

            {/* Added Attendance & Leave Tracker */}
            <Route path='/attendance-tracker' element={<AttendanceTracker />} />
            <Route path='/leave-tracker' element={<LeaveTracker />} />
            <Route path='/approvals-tracker' element={<ApprovalsTracker />} />

            {/* Added Quality Analysis */}
            <Route path="/main-content" element={<MainContent />} />
            <Route path="/recording-feedback/:engagementTrackingId/:engagementCoachUserId" element={<QaRecordingFeedback />} />
            <Route path="/location-view" element={<LocationView/>} />
            <Route path="/coach-view" element={<CoachView/>} />
            <Route path="/qa-view" element={<QAView/>} />
            <Route path="/slot-booking-total" element={<SlotBookingEngagement/>} />
  
            {/* KPI Dashboard */}
            <Route path="/kpi-calling" element={<CallingKpi />} />
            <Route path="/kpi-historical-dashboard" element={<KpiDashboardHistory/>} />

            {/* SSOT Dashboard */}
            <Route path="/ssot" element={<SSOT />} />

            {/* Added Incentives Calculator */}
            <Route path="/incentives-slab" element={<IncentiveSlab/>} />
            <Route path="/incentives-achievedScore" element={<AchievedScore/>} />
            <Route path="/weightage-target" element={<WeightageAndTarget/>} />
            <Route path="/incentives-calculator" element={<CallingIncentives/>} />
            </>
          );
      case "medrep_ext_ss":
        return (
          <>
            <Route path='/myTickets' element={<Tickets />} />
          </>
        );
      case "medrep_ext_cnx":
        return (
          <>
            <Route path='/myTickets' element={<Tickets />} />
          </>
        );
      case "dispatch":
        return (
          <>
            <Route path="dashboard" element={<DashboardDispatch />} />
            <Route path="/myTickets" element={<Tickets />} />
            <Route
              path="case-management/sales-management"
              element={<SalesManagement />}
            />

            <Route path="/case-management/new-leads" element={<AllLeads />} />
            <Route path="/case-management/all-leads" element={<AllLeads />} />
            <Route path="/case-management/all-cases" element={<AllLeads />} />
            <Route
              path="/case-management/slotBooking"
              element={<CaseSlotBooking />}
            />
            <Route path="/order-management" element={<OrderMovement />} />
            <Route
              path="/order-management/allOrder"
              element={<AllOrdersManagement />}
            />
            <Route
              path="/order-management/update_order"
              element={<UpdateOrders />}
            />
            <Route
              path="/order-management/open_orders"
              element={<OpenOrders />}
            />
            <Route
              path="/order-management/recent_orders"
              element={<RecentOrders />}
            />
            <Route
              path="/order-management/assigned-doctors"
              element={<AssignedDoctors />}
            />
            <Route path="search" element={<Search />} />

            <Route path="/misc-orders" element={<ODAList />} />
            <Route path="/invoice" element={<Invoice />} />
            <Route path="zoho" element={<Zoho />} />
            <Route
              path="/order-management/ghost-orders"
              element={<GhostOrders />}
            />

            {/* Added Attendance & Leave Tracker */}
            <Route path='/attendance-tracker' element={<AttendanceTracker />} />
            <Route path='/leave-tracker' element={<LeaveTracker />} />
          </>
        );
      case "sales":
        return (
          <>
            <Route path="dashboard" element={<TodayEngagement />} />
            <Route path="/myTickets" element={<Tickets />} />
            <Route path="/next-call" element={<NextCall />} />
            <Route
              path="/next-call/:id"
              element={<LeadDetails nextCall={true} />}
            />

            {/* Added Attendance & Leave Tracker */}
            <Route path='/attendance-tracker' element={<AttendanceTracker />} />
            <Route path='/leave-tracker' element={<LeaveTracker />} />
          </>
        );
      case "medrep_ext_cnx":
        return (
          <>
            <Route path="/myTickets" element={<Tickets />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route
              path="/"
              element={<Navigate to={"/dashboard?tab=home"} replace />}
            />
            <Route
              path="/dashboard/home/assigned-orders"
              element={<CustomersList assignedOrder={true} />}
            />
            <Route
              path="dashboard/revenue-report"
              element={<RevenueReport />}
            />
            <Route path="engagementReport" element={<EngagementRep />} />
            <Route path="/main-content" element={<MainContent />} />
          </>
        );
      case "clinic_admin":
        return (
          <>
            <Route path="/myTickets" element={<Tickets />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route
              path="/"
              element={<Navigate to={"/dashboard?tab=home"} replace />}
            />
            <Route
              path="/dashboard/home/assigned-orders"
              element={<CustomersList assignedOrder={true} />}
            />
            <Route
              path="dashboard/revenue-report"
              element={<RevenueReport />}
            />
            <Route path="clinic-dashboard" element={<ClinicsDashBoard />} />
            <Route
              path="/order-management/allOrder"
              element={<AllOrdersManagement />}
            />

            <Route
              path="/order-management/assigned-doctors"
              element={<AssignedDoctors />}
            />

            {/* Added Attendance & Leave Tracker */}
            <Route path='/attendance-tracker' element={<AttendanceTracker />} />
            <Route path='/leave-tracker' element={<LeaveTracker />} />
          </>
        );
      case "clinic_receptionist":
        return (
          <>
            <Route path="/myTickets" element={<Tickets />} />
            <Route path="clinic-dashboard" element={<ClinicsDashBoard />} />
            <Route path="/receptioninst-dashboard" element={<ReceptionistTodayEngagement />} />
          </>
        );
      case "ivr":
        return (
          <>
            {/* Added Quality Analysis */}
            <Route path="/main-content" element={<MainContent />} />
            <Route path="/recording-feedback/:engagementTrackingId/:engagementCoachUserId" element={<QaRecordingFeedback />} />
          </>
        );
      case 'clinic_doctor':
        return (
          <>
            <Route path='dashboard' element={<Dashboard />} />
            <Route path='doctor-booking' element={<DoctorBooking />} />
            <Route path='clinic_home' element={<DoctorDashboard />} />
            <Route path='/my-appointments' element={<MyAppointment />} />
            <Route
              path='/prescribed-patients'
              element={<PrescribedPatients />}
            />
          </>
        );
      case "maker":
        return (
          <>
            <Route path="dashboard" element={<Dashboard />} />
          </>
        );
      case "checker":
        return (
          <>
            <Route path="dashboard" element={<Dashboard />} />
          </>
        );
      case "publisher":
        return (
          <>
            <Route path="dashboard" element={<Dashboard />} />
          </>
          );
      default:
        return (
          <Route
            path="/"
            element={
              <Navigate
                to={
                  getCurrentUserRole() === "doctor" ||
                    getCurrentUserRole() === "consult_doctor"
                    ? "/dashboard"
                    : "/dashboard?tab=home"
                }
                replace
              />
            }
          />
        );
    }
  };

  return (
    <>
    <Routes>   
      <Route element={<ErrorLayout />}>
        <Route path="errors/404" element={<Error404 />} />
        <Route path="errors/500" element={<Error500 />} />
      </Route>
      <Route path="login" element={<Login />} />
      <Route path="reset-password/:id" element={<ResetPassword />} />
      {/* <Route path="/loginWithOtp" element={<InputOTPPage />} />   */}
      {!token ? (
        <>
          <Route path="*" element={<Login />} />
          <Route path="/loginWithOtp" element={<InputOTPPage />} />
          <Route path="reset-password/:id" element={<dResetPassword />} />
        </>
      ) : (
        <Route path="/" element={<MainLayout />}>
          <Route
            path={
              ['ivr', 'medical'].includes(userRole)
                ? '/dashboard'
                : 'dashboard/home'
            }
            element={
              ['ivr', 'medical'].includes(userRole) ? (
                <TodayEngagement />
              ) : (
                <Home />
              )
            }
          />
          {/* Added Attendance & Leave Tracker */}
          <Route
            path="/attendance-tracker"
            element={<AttendanceTracker />}
          />
          <Route path="/leave-tracker" element={<LeaveTracker />} />
          <Route path="dashboard/home" element={<Home />} />
          <Route
            path={
              getCurrentUserRole === "consult_doctor"
                ? "home/:id"
                : getCurrentUserRole == "doctor"
                  ? "home/:id"
                  : "home"
            }
            element={
              getCurrentUserRole() == "doctor" ? (
                <DoctorDashboard />
              ) : getCurrentUserRole() == "consult_doctor" ? (
                <DoctorsTab />
              ) : (
                <Home />
              )
            }
          />

          {/* <Route path="/loginWithOtp" element={<InputOTPPage />} /> */}
          <Route path='/case-management/all-cases-tag' element={<AllLeadsTag />} />
          <Route path="/" element={<Navigate to={homeRoute()} replace />} />
          <Route path="/productivity-dashboard" element={<ProductivityDashboard />} />
          <Route path="lead-details/:id" element={<LeadDetails />} />
          <Route path="lead-details/:id" element={<LeadDetails />} />
          <Route path="/edit-user/:userid" element={<EditUsers />} />
          <Route path="/myTickets" element={<Tickets />} />
          <Route path="/complaints-incentives" element={<ComplaintIncentives/>} />
          <Route path='/medical-kpi' element={<MedicalKpi/>}/>
          <Route path="/complaint-kpi" element={<ComplaintKpi/>} />
          <Route path="/medical-incentives" element={<MedicalIncentives/>} />
          <Route path="/incentives-calculator" element={<CallingIncentives/>} />
          <Route path="/user-management" element={<UserManagement />} />
          {userSpecificRoutes()}
        </Route>
      )}
      {token ? (
        <Route path="*" element={<Navigate to="/errors/404" replace />} />
      ) : (
        <>
          <Route path="/" element={<Login />} />
          <Route path="/loginWithOtp" element={<InputOTPPage />} />
          <Route path="reset-password/:id" element={<ResetPassword />} />
        </>
      )}
    </Routes>
    </>
  );
};

export default CRMRoutes;